/* eslint no-underscore-dangle: 0 */

import $ from 'jquery';

const aside = () => {
    const $aside = $('aside');

    if ($aside.length === 0) return;

    if ($aside.find('div').length < 1) {
        $aside.remove();
    }
};

const submitForm = () => {
    const $form = $('.form-layout');
    const $submitForm = $form.find('input[type=submit]', this);

    if ($form.length === 0) return;

    $submitForm.on('click', e => {
        const submitBtnName = e.target.getAttribute('name');
        window.__doPostBack(submitBtnName, '');
    });
};

const pagination = () => {
    const $pagination = $('.c-pagination-simple');
    const $paginationLink = $pagination.find('a', this);

    if ($pagination.length === 0) return;

    $paginationLink.on('click', e => {
        if ($(e.target).hasClass('disabled')) {
            e.preventDefault();
        }
    });
};

// doc ready
$(() => {
    aside();
    pagination();
    submitForm();
});



// WEBPACK FOOTER //
// ./src/sections/two-col-container/s-two-col-container.js